module.exports = __webpack_public_path__ + "static/media/calender.3de2e23d.svg";